// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"guFF3zJfbvozPKXtGXcjp","QuizWrapper":"_3Hy2q9OwZ4tWGTWDFAbBdV"};